<template>
  <div>
    <div class="rg">
      <div>
        <div class="cir">
          <div class="circ">
            <div class="circm">
              <div class="crc">
                <div>
                  <div class="rnd">
                    <div>
                      <div>
                        <span>Vue</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="crc">
                <div>
                  <div class="rnd">
                    <div>
                      <div>
                        <span>JS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="crc">
                <div>
                  <div class="rnd">
                    <div>
                      <div>
                        <span>HTML</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="crc">
                <div>
                  <div class="rnd">
                    <div>
                      <div>
                        <span>Sass</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

import gsap from "gsap-3";
import ScrollTrigger from "gsap-3/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: "V2Circle",
  data() {
    return {
      elemTop: 0,
    };
  },
  mounted() {
    this.elemTop = $(".js-hero-wrap").offset().top;

    this.onScroll();

    gsap
      .from(".rg", 1, {
        opacity: 0,
        scale: 0.7,
      })
      .delay(3);
    this.init();
  },
  methods: {
    init() {
      //for more see https://www.point-web.fr/
      var $win = $(window);

      gsap.from(".circ", 1, {
        rotation: 90,
        scrollTrigger: {
          trigger: ".js-hero-wrap",
          start: "top bottom",
          end: "top top",
          scrub: true,
        },
      });

      var $tl1 = gsap.timeline({
        scrollTrigger: {
          trigger: ".js-hero-wrap",
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      });
      $tl1.to(".circm", 1, { rotation: -180 }, "a");
      $tl1.to(".rnd span", 1, { rotation: 180 }, "a");

      var $tl2 = gsap.timeline({
        scrollTrigger: {
          trigger: ".js-hero-wrap",
          start: "top bottom",
          end: "bottom bottom",
          scrub: true,
        },
      });
      $tl2.staggerFrom(".rnd span", 0.25, { opacity: 0, scale: 0 }, 0.25, "a");
      $tl2.staggerTo(
        ".rnd > div > div",
        0.25,
        { width: "100%", height: "100%" },
        0.25,
        "a"
      );

      var $tl3 = gsap.timeline({
        scrollTrigger: {
          trigger: ".js-hero-wrap",
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      });
      $tl3.staggerTo(
        ".rnd > div > div",
        0.25,
        { width: "5%", height: "5%" },
        0.25,
        "a"
      );
      $tl3.staggerTo(".rnd span", 0.25, { opacity: 0, scale: 0 }, 0.25, "a");

      var $tl4 = gsap.timeline({
        scrollTrigger: {
          trigger: ".sp-2",
          start: "top bottom",
          end: "bottom bottom",
          scrub: true,
        },
      });
      if ($win.width() >= 992) {
        $tl4.to(".rg", 0.25, { paddingLeft: "50%" }, "a");
        $tl4.to(".rg > div", 0.25, { y: "0%" }, "a");
        $tl4.to(".cir", 0.25, { rotation: -150, x: "-50%" }, "a");
      } else {
        $tl4.to(".rg", 0.25, { paddingLeft: "0" }, "a");
        $tl4.to(
          ".rg > div",
          0.25,
          {
            y:
              $win.outerHeight() / 2 -
              $(".rg").outerHeight() / 2 -
              $(".rg").outerHeight() / 3,
          },
          "a"
        );
        $tl4.to(".cir", 0.25, { rotation: -150, x: "0" }, "a");
      }
      $tl4.to(
        ".crc:nth-child(2) > div, .crc:nth-child(4) > div",
        0.25,
        { height: "0%" },
        "a"
      );
      $tl4.to(
        ".crc:nth-child(1) > div, .crc:nth-child(3) > div",
        0.25,
        { width: "0%" },
        "a"
      );

      var $tl5;
      if ($win.width() >= 1200) {
        $tl5 = gsap.timeline({
          scrollTrigger: {
            trigger: ".sp-2",
            start: "top top",
            end: "bottom top",
            scrub: true,
          },
        });
      } else {
        $tl5 = gsap.timeline({
          scrollTrigger: {
            trigger: ".sp-2",
            start: "top 50%",
            end: "bottom 10%",
            scrub: true,
          },
        });
      }
      $tl5
        .to(
          ".crc > div",
          0.1,
          {
            scale: 0,
          },
          "a"
        )
        .to(
          ".cir",
          0.1,
          {
            scale: 0,
            opacity: 0,
          },
          "a"
        );
    },
    onScroll() {
      var elemTop = this.elemTop;

      $(window).scroll(function() {
        //get the location of an element relative to window
        var y = elemTop - $(window).scrollTop() - 100;
        // $(".rg").css({ marginTop: -y });
        gsap.to(".rg", 0, {
          marginTop: -y,
        });
      });
    },
  },
};
</script>
